import { ReadonlySignal } from '@preact/signals-react';

export abstract class AppMenuState {
  abstract readonly open: ReadonlySignal<boolean>;
  abstract setOpen(open: boolean): void;
}
